export const exportFileWithinLimit = (
  fileSizeBytes: number,
  maxFileBytes: number
) =>
  Number.isSafeInteger(maxFileBytes) &&
  maxFileBytes > 0 &&
  Number.isSafeInteger(fileSizeBytes) &&
  fileSizeBytes >= 0 &&
  fileSizeBytes <= maxFileBytes

export const MAX_SYNCHRONOUS_EXPORT_BYTES = 64 * 1024 * 1024

export type BookingExportPayload = {
  data: Record<string, unknown>[]
  maxFileBytes: number
}

export const encodedPayloadWithinAbsoluteLimit = (encoded: string) => {
  if (typeof encoded !== 'string' || encoded.length === 0) return false
  const padding = encoded.endsWith('==') ? 2 : encoded.endsWith('=') ? 1 : 0
  const decodedBytes = Math.floor((encoded.length * 3) / 4) - padding
  return exportFileWithinLimit(decodedBytes, MAX_SYNCHRONOUS_EXPORT_BYTES)
}

export const decodeBookingExportPayload = (
  encoded: string
): BookingExportPayload => {
  if (!encodedPayloadWithinAbsoluteLimit(encoded)) {
    throw new Error('EXPORT_FILE_SIZE_LIMIT_EXCEEDED')
  }
  const decodedData = atob(encoded)
  const parsed: unknown = JSON.parse(decodeURIComponent(escape(decodedData)))
  if (
    typeof parsed !== 'object' ||
    parsed === null ||
    !Array.isArray((parsed as BookingExportPayload).data) ||
    !Number.isSafeInteger((parsed as BookingExportPayload).maxFileBytes) ||
    (parsed as BookingExportPayload).maxFileBytes < 1 ||
    (parsed as BookingExportPayload).maxFileBytes > MAX_SYNCHRONOUS_EXPORT_BYTES
  ) {
    throw new Error('EXPORT_POLICY_UNAVAILABLE')
  }
  return parsed as BookingExportPayload
}
